/* eslint-disable */
import { Route as rootRoute } from './routes/__root';
import { Route as IndexImport } from './routes/index';
import { Route as TopologyImport } from './routes/topology';
import { Route as EquipmentImport } from './routes/equipment';
import { Route as UsersImport } from './routes/users';
import { Route as SessionsImport } from './routes/sessions';
import { Route as DepartmentsImport } from './routes/departments';
import { Route as LocationsImport } from './routes/locations';
import { Route as AuditImport } from './routes/audit';
import { Route as ReportsImport } from './routes/reports';
import { Route as StatusImport } from './routes/status';
import { Route as GatewayImport } from './routes/gateway';
const IndexRoute = IndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => rootRoute,
});
const TopologyRoute = TopologyImport.update({
    id: '/topology',
    path: '/topology',
    getParentRoute: () => rootRoute,
});
const EquipmentRoute = EquipmentImport.update({
    id: '/equipment',
    path: '/equipment',
    getParentRoute: () => rootRoute,
});
const UsersRoute = UsersImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => rootRoute,
});
const SessionsRoute = SessionsImport.update({
    id: '/sessions',
    path: '/sessions',
    getParentRoute: () => rootRoute,
});
const DepartmentsRoute = DepartmentsImport.update({
    id: '/departments',
    path: '/departments',
    getParentRoute: () => rootRoute,
});
const LocationsRoute = LocationsImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => rootRoute,
});
const AuditRoute = AuditImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => rootRoute,
});
const ReportsRoute = ReportsImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => rootRoute,
});
const StatusRoute = StatusImport.update({
    id: '/status',
    path: '/status',
    getParentRoute: () => rootRoute,
});
const GatewayRoute = GatewayImport.update({
    id: '/gateway',
    path: '/gateway',
    getParentRoute: () => rootRoute,
});
export const routeTree = rootRoute.addChildren({
    IndexRoute,
    TopologyRoute,
    EquipmentRoute,
    UsersRoute,
    SessionsRoute,
    DepartmentsRoute,
    LocationsRoute,
    AuditRoute,
    ReportsRoute,
    StatusRoute,
    GatewayRoute,
});
//# sourceMappingURL=routeTree.gen.js.map